import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { RadioCheckBoxEnum } from '../../common/radio.checkbox.enums';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_760 implements Validator {

    public static id = 'CTRL_760';
    private message = 'error.ctr_760';


    public LOG: LogService = new LogService(CTRL_760);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_760.id + '_');


        if (rgs.length > 0) {
            for (const rg of rgs){
                const ctrl = form.controls[rg];
                const firstNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const thirdNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const fourthNameWithStepId = map.get(ctrl.value.rgCtrls.fourthChamp);
                const fifthNameWithStepId = map.get(ctrl.value.rgCtrls.fifthChamp);
                const sixthNameWithStepId = map.get(ctrl.value.rgCtrls.sixthChamp);
                const firstCtrl = form.controls[firstNameWithStepId];
                const thirdCtrl = form.controls[thirdNameWithStepId];
                const fourthCtrl = form.controls[fourthNameWithStepId];
                const fifthCtrl = form.controls[fifthNameWithStepId];
                const sixthCtrl = form.controls[sixthNameWithStepId];
                if ((firstCtrl.value == RadioCheckBoxEnum.dialogueCompetitif)
                    && (thirdCtrl.value !== null && fourthCtrl.value !== null && fifthCtrl.value !== null && sixthCtrl.value !== null )) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
